/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import MfaCodeEntry from 'components/pages/mfaCode';

import userSelectors from 'redux/reduxStore/user';
import sessionSelectors from 'redux/reduxStore/session';

import routeNames from 'lib/routeNames';

function mapStateToProps(state) {
  return {
    isLoggedIn: sessionSelectors.isLoggedIn(),
    requiresMfa: sessionSelectors.requiresMfa(),
  };
}

function mapDispatchToProps(dispatch) {
  return {}
}

class LoginMfa extends React.Component {
  render() {
    const requiresMfa = sessionSelectors.requiresMfa();
    if (this.props.isLoggedIn) { return <Redirect to={routeNames.home()} />; }
    if (!this.props.requiresMfa) { return <Redirect to={routeNames.loginEmail()} />; }

    return (
      <MfaCodeEntry
        submitMfaCode={(mfaCode) => {
          return this.props.loginWithMfa(mfaCode);
        }}
        goBack={this.props.logout}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginMfa);
